import { useState } from "react";
import { Package, Loader2 } from "lucide-react";
import { downloadSocialPack } from "@/lib/social-pack";

interface Props {
  title: string;
  subtitle?: string | null;
  scrollCard?: string | null;
  activationNumber?: number | null;
  seriesLabel?: string | null;
  heroImageUrl?: string | null;
  slug: string;
}

export function SocialPackButton(props: Props) {
  const [busy, setBusy] = useState(false);
  async function go() {
    setBusy(true);
    try { await downloadSocialPack(props); } finally { setBusy(false); }
  }
  return (
    <button onClick={go} disabled={busy}
      className="inline-flex items-center gap-2 rounded-full border hairline px-4 py-2 text-xs uppercase tracking-[0.2em] hover:border-gold hover:text-gold disabled:opacity-50">
      {busy ? <Loader2 size={14} className="animate-spin" /> : <Package size={14} />}
      {busy ? "Rendering pack..." : "Download social pack"}
    </button>
  );
}
